export enum MaterialType {
  LineMaterial = 'line-material',
  LineBasicMaterial = 'line-basic-material',
  MeshBasicMaterial = 'mesh-basic',
  MeshLambert = 'mesh-lambert',
  MeshStandard = 'mesh-standard',
  MeshPhong = 'mesh-phong',
  MeshPhongAntitiling = 'mesh-phong-antitiling',
}
